const NATIONAL_ANNOUNCEMENT_DAY = "March 25 2026 15:00:00 GMT-0400";
export const announceDate = new Date(NATIONAL_ANNOUNCEMENT_DAY);
export const programYear = announceDate.getFullYear();
export const isAnnounced = Date.now() >= announceDate;
export const upToDate = `This list is up to date as of ${announceDate.toLocaleDateString('en-US', { month: 'long', day: 'numeric' })}, `;